export const tickerItems = [
  { stat: '4', label: 'Focus Areas' },
  { stat: '8', label: 'SDG Goals Aligned' },
  { stat: '7', label: 'Advisory Board Members' },
  { stat: null, label: 'Agriculture · Forestry · Livelihood · Sustainability' },
];
